import { Box, TextField } from '@mui/material'
import { FC, useEffect, useState, useContext } from 'react'
import { useDebounce } from 'use-debounce'

import { AccountsReceivableContext } from '../../../../context/AccountsReceivableContext'

const AccountsReceivableFilters: FC = () => {
  const { setFilters } = useContext(AccountsReceivableContext)
  const [searchTerm, setSearchTerm] = useState<string>('')

  const [debouncedSearchTerm] = useDebounce(searchTerm, 500)

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value)
  }

  useEffect(() => {
    setFilters({ searchTerm: debouncedSearchTerm })
  }, [debouncedSearchTerm, setFilters])

  return (
    <Box display="flex" gap={2} alignItems="center" flexWrap="wrap" sx={{ px: 2, pt: 3, pb: 4 }}>
      <TextField
        label="Search"
        placeholder="Search by invoice #, matter # or client name"
        value={searchTerm}
        sx={{ minWidth: 350 }}
        onChange={handleSearchChange}
      />
    </Box>
  )
}

export default AccountsReceivableFilters
